import { render, staticRenderFns } from "./msp.vue?vue&type=template&id=5e6d7198&scoped=true&"
import script from "./msp.vue?vue&type=script&lang=js&"
export * from "./msp.vue?vue&type=script&lang=js&"
import style0 from "./msp.vue?vue&type=style&index=0&id=5e6d7198&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e6d7198",
  null
  
)

export default component.exports